<template>
  <div class="relative flex items-start min-h-screen w-full max-w-full overflow-x-clip bg-slate-50 dark:bg-slate-900">
    <!-- Sidebar -->
    <AdminSidebar
      :is-collapsed="isSidebarCollapsed"
      :is-open-mobile="isSidebarOpenMobile"
      :sidebar-search="sidebarSearch"
      :lang="lang"
      :t="t"
      @update:sidebar-search="sidebarSearch = $event"
    />


    <!-- Main content -->
    <div class="flex flex-col flex-1 min-w-0 w-full">
      <!-- Top bar -->
      <AdminTopbar
        :is-collapsed="isSidebarCollapsed"
        :lang="lang"
        :t="t"
        @toggle-sidebar="toggleSidebar"
      />

      <main class="flex-1 px-4 py-6 md:px-6 lg:px-8">
        <consultantDashboardStatistics />
        <ConsultationsOverview/>
      </main>
    </div>
  </div>
</template>

<script setup>
import { computed, onBeforeUnmount, onMounted, ref } from "vue";
import { messages } from "@/i18n";

import AdminSidebar from "@/components/Auth/Sidebar.vue";
import AdminTopbar from "@/components/Auth/TopNav.vue";
import consultantDashboardStatistics from "@/components/Analysis/consultantDashboardStatistics.vue";
import ConsultationsOverview from "@/components/Analysis/ConsultationsOverview.vue";
/* ---------------- lang (same idea as About) ---------------- */
const normalizeLang = (raw) =>
  String(raw || "").toLowerCase().startsWith("en") ? "en" : "ar";

const lang = ref(
  normalizeLang(
    document.documentElement.lang || localStorage.getItem("app_lang") || "ar"
  )
);

/**
 * ✅ translator function like About
 * supports simple {var} interpolation
 */
const t = (key, vars = null) => {
  const val = messages?.[lang.value]?.[key];
  if (val == null) return key;

  if (vars && typeof val === "string") {
    return val.replace(/\{(\w+)\}/g, (_, k) =>
      vars?.[k] ?? `{${k}}`
    );
  }
  return val;
};

/* ---------------- Layout state ---------------- */
const isSidebarCollapsed = ref(false);
const isSidebarOpenMobile = ref(false);
const sidebarSearch = ref("");

function toggleSidebar() {
  // مثال بسيط (عدّل حسب منطقك)
  if (window.innerWidth < 768) {
    isSidebarOpenMobile.value = !isSidebarOpenMobile.value;
  } else {
    isSidebarCollapsed.value = !isSidebarCollapsed.value;
  }
}

/* ---------------- sync lang updates ---------------- */
let observer = null;

const onAppLang = (e) => {
  const next = normalizeLang(e?.detail || "ar");
  if (next !== lang.value) lang.value = next;
};

onMounted(() => {
  window.addEventListener("app:lang", onAppLang, { passive: true });

  observer = new MutationObserver((muts) => {
    for (const m of muts) {
      if (m?.attributeName === "lang" || m?.attributeName === "dir") {
        const htmlLang = normalizeLang(
          document.documentElement.lang || localStorage.getItem("app_lang") || "ar"
        );
        if (htmlLang !== lang.value) lang.value = htmlLang;
      }
    }
  });

  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ["lang", "dir"],
  });
});

onBeforeUnmount(() => {
  window.removeEventListener("app:lang", onAppLang);
  if (observer) observer.disconnect();
});
</script>
